<div class="modal-overlay" ></div>
<div class="modal-wrap">
  <div class="modal-information">

    <div class="modal-content">

      <picture>
        <source
          media="(max-width: 600px)"
          srcset="assets/images/ui-kit-img/modal-info-img-mobile.svg">

        <source
          srcset="assets/images/ui-kit-img/modal-info-img.webp"
          type="image/webp">

        <img
          class="modal-img-info"
          src="assets/images/ui-kit-img/modal-info-img.svg"
          width="537"
          height="366"
          alt="Description">
      </picture>


      <img class="modal-img-arrow"  src="assets/icons/arrow-modal.svg" alt="arrow-modal">

      <div class="modal-footer">
        <div class="modal-footer-text-wrap">
          <p class="din-pro-condensed modal-footer-text">После просмотра видео <br/>
            нажмите кнопку «Лекция пройдена» — вам станет доступен следующий урок</p>
        </div>
        <button class="button active" (click)="closeModal()">Понятно</button>
      </div>
    </div>

  </div>
</div>
